import { OmpImageRatio, OmpImageSlot } from '../../_models';

// Shared so Image Banner and Text and Image cannot drift apart on what they tell a merchant
// to upload.

// Widest the uploader will store; anything larger is downscaled on upload.
const MAX_STORED_WIDTH = 1600;
const MOBILE_CSS_WIDTH = 430;
const PIXEL_RATIO = 2;
const MIN_SLOT_WIDTH = 200;

export function ompDesktopImageWidth(slot: OmpImageSlot): number {
  const columns = Math.max(1, +slot.columnCount || 1);
  const share = slot.share === undefined ? 1 : slot.share;
  const gross = (+slot.contentWidth || 0) - 2 * (+slot.horizontalPadding || 0);
  const css = Math.max(MIN_SLOT_WIDTH, (gross / columns) * share);
  return Math.min(MAX_STORED_WIDTH, Math.round(css * PIXEL_RATIO));
}

export function ompMobileImageWidth(): number {
  return MOBILE_CSS_WIDTH * PIXEL_RATIO;
}

export function ompImageSizeHint(width: number, ratio: string): string {
  let height = Math.round((width * 9) / 16);
  if (ratio === OmpImageRatio.FourThree) {
    height = Math.round((width * 3) / 4);
  } else if (ratio === OmpImageRatio.Square) {
    height = width;
  }
  return 'Recommended: ' + width + ' x ' + height + ' px';
}

export function ompPageBackgroundHint(): string {
  return ompImageSizeHint(MAX_STORED_WIDTH, OmpImageRatio.Square) + ' — Png, Jpg';
}
